var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'more-dropdown': true, left: _vm.placement.includes('left'), right: _vm.placement.includes('right'), top: _vm.placement.includes('top'), bottom: _vm.placement.includes('bottom')}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }